import { Link } from "react-router-dom";
import { images } from "../../assets/assets";
import Navbar from "../../Components/Navbar";
import {
  Activity,
  Calendar,
  Clipboard,
  FileText,
  MoveRight,
  Phone,
  UserCheck,
} from "lucide-react";
import Footer from "../../Components/Footer";
import { getImageUrl } from "../../utils/getImageUrl";
import { useState, useEffect } from "react";
import { getAllServices } from "../../api";

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getAllServices();
        setServices(response?.data || []);
      } catch (err) {
        console.error("Error fetching services:", err);
        setError("Failed to load services. Please try again later.");
        setServices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  // Skeleton Loader Component
  const SkeletonLoader = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
      {[1, 2, 3, 4].map((idx) => (
        <div key={idx} className="bg-[#C9DCDE33] rounded-[10px] p-4 flex flex-col sm:flex-row gap-3 sm:gap-2">
          <div className="w-full sm:w-[40%] h-[200px] sm:h-auto bg-gray-200 rounded-[8px] animate-pulse"></div>
          <div className="flex-1 space-y-3">
            <div className="h-5 bg-gray-200 rounded animate-pulse w-3/4"></div>
            <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6"></div>
            <div className="space-y-2 mt-4">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-4/5"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-4/5"></div>
              <div className="h-4 bg-gray-200 rounded animate-pulse w-4/5"></div>
            </div>
            <div className="grid grid-cols-2 gap-2 mt-4">
              <div className="h-10 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-10 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  // const services = [
  //   {
  //     imagePath: images.ServiceOne,
  //     name: "Medicine Department ",
  //     shortDesc:
  //       "Our medicine department provides comprehensive care for a wide range of general health conditions, focusing on ac..",
  //     offeredServices: [
  //       "General Health Checkups",
  //       "Diabetes Management",
  //       "Hypertension Treatment",
  //       "Fever & Infection Care",
  //     ],
  //   },
  //   {
  //     img: images.ServiceTwo,
  //     name: "Obstetrics and Gynaecology Department",
  //     shortDesc:
  //       "Our Obstetrics and Gynaecology department provides comprehensive care for women at every stage of life, from adolescence...",
  //     services: [
  //       "Pregnancy & Antenatal Care",
  //       "Normal & Cesarean Delivery",
  //       "Menstrual Disorder Treatment",
  //       "Infertility Evaluation & Care",
  //     ],
  //   },
  //   {
  //     img: images.ServiceThree,
  //     name: "General Surgery Department ",
  //     shortDesc:
  //       "Our General Surgery department offers advanced surgical care for a wide range of conditions using modern techniques and a patient-centered approach...",
  //     services: [
  //       "Laparoscopic (Minimally Invasive) Surgery",
  //       "Hernia & Appendix Surgery",
  //       "Gallbladder (Gallstone) Surgery",
  //       "Gastrointestinal Surgery",
  //     ],
  //   },
  //   {
  //     img: images.ServiceFour,
  //     name: "Paediatrics Department",
  //     shortDesc:
  //       "Our Paediatrics department provides specialized healthcare for infants, children, and adolescents, focusing on growth, development, and overall well-being. We ensure compassionate care, accurate diagnosis, and preventive treatments in a child-friendly and safe environment.",
  //     services: [
  //       "Newborn & Infant Care",
  //       "Vaccination & Immunization",
  //       "Growth & Development Monitoring",
  //       "Treatment of Childhood Illnesses",
  //     ],
  //   },
  //   {
  //     img: images.ServiceFive,
  //     name: "Urology Department",
  //     shortDesc:
  //       "Our Urology department provides advanced care for urinary tract and male reproductive system disorders. With modern diagnostic tools and expert specialists, we ensure accurate treatment, patient comfort, and effective recovery for all urological conditions.",
  //     services: [
  //       "Kidney Stone Treatment",
  //       "Urinary Tract Infection (UTI) Care",
  //       "Prostate Disorder Treatment",
  //       "Bladder & Kidney Care",
  //     ],
  //   },
  //   {
  //     img: images.ServicesSix,
  //     name: "Ophthalmology Department",
  //     shortDesc:
  //       "Our Ophthalmology department provides comprehensive eye care services, focusing on accurate diagnosis, advanced treatment, and vision correction. We ensure high-quality care for all age groups with modern equipment and experienced specialists.",
  //     services: [
  //       "Eye Checkups & Vision Testing",
  //       "Cataract Diagnosis & Surgery",
  //       "Glaucoma Management",
  //       "Refractive Error Correction",
  //     ],
  //   },
  //   {
  //     img: images.ServiceSeven,
  //     name: "Orthopaedic Department",
  //     shortDesc:
  //       "Our Orthopaedic department provides expert care for bone, joint, and muscle conditions, focusing on accurate diagnosis, effective treatment, and faster recovery. We use advanced techniques and personalized care plans to restore mobility and improve quality of life.",
  //     services: [
  //       "Fracture & Trauma Care",
  //       "Joint Pain & Arthritis Treatment",
  //       "Sports Injury Management",
  //       "Joint Replacement (Knee & Hip)",
  //     ],
  //   },
  // ];
  return (
    <div className="font-lato">
      <Navbar />
      {/* Top Page Heading */}
      <div className="bg-[#F7F7F7B2] py-4 flex justify-center px-4">
        <div className="flex gap-2 items-center">
          <img
            src={images.Logo}
            alt="logo"
            className="w-[60px] h-[60px] md:w-[110px] md:h-[110px]"
          />
          <div className="max-w-[350px]">
            <p className="font-bold text-[18px] sm:text-[20px] md:text-[22px]">
              Medical Services
            </p>
            <p className="font-openSans text-[14px] leading-[1.2]">
              Dev Rishi Hospital offers a complete range of healthcare services
              designed to meet the needs of patients at every stage. Our
              multidisciplinary approach ensures comprehensive care for all
              medical conditions.
            </p>
          </div>
        </div>
      </div>
      {/* Service Card */}
      <div className="max-w-[1190px] mx-auto py-4 px-4">
        {/* Loading State */}
        {loading && <SkeletonLoader />}

        {/* Error State */}
        {error && !loading && (
          <div className="flex flex-col items-center justify-center py-12">
            <div className="text-center">
              <p className="text-lg font-semibold text-red-600 mb-2">⚠️ Error</p>
              <p className="text-gray-600 mb-4">{error}</p>
              <button
                onClick={() => window.location.reload()}
                className="bg-[#1975FF] text-white px-6 py-2 rounded-[8px] hover:bg-[#1560d4] transition-colors duration-200"
              >
                Try Again
              </button>
            </div>
          </div>
        )}

        {/* Empty State */}
        {!loading && !error && services.length === 0 && (
          <div className="flex flex-col items-center justify-center py-12">
            <div className="text-center">
              <p className="text-lg font-semibold text-gray-600 mb-2">📋 No Services Available</p>
              <p className="text-gray-500">Services will be available soon. Please check back later.</p>
            </div>
          </div>
        )}

        {/* Services Grid */}
        {!loading && !error && services.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
            {services.map((service, idx) => (
          <div
            key={idx}
            className="bg-[#C9DCDE33] rounded-[10px] p-4 flex flex-col sm:flex-row gap-3 sm:gap-2 hover:bg-[#C9DCDE66] hover:shadow-lg hover:-translate-y-1 active:scale-[0.98] active:shadow-md transition-all duration-300 border border-transparent hover:border-[#1975FF33] cursor-pointer"
          >
            <div
              className="w-full sm:w-[40%] h-[200px] sm:h-auto bg-cover bg-center rounded-[8px]"
              style={{
                backgroundImage: `linear-gradient(180deg, rgba(102, 102, 102, 0) 40.87%, rgba(23, 23, 23, 0.545192) 69.71%, rgba(14, 14, 14, 0.56) 73.56%, rgba(0, 0, 0, 0.63) 88.94%), url(${getImageUrl(service.imagePath)})`,
              }}
            ></div>
            <div className="flex-1 pr-0 sm:pr-4 flex flex-col justify-between">
              <div>
                <p className="font-semibold text-[16px] sm:text-[17px] line-clamp-1 group-hover:text-[#1975FF] transition-colors duration-300">
                  {service.name}
                </p>
                <p className="text-[13px] sm:text-[14px] font-openSans my-2 line-clamp-2 sm:line-clamp-3">
                  {service.shortDesc}
                </p>
                <p className="font-semibold text-[14px] sm:text-base">
                  Services Include:
                </p>
                <div className="flex flex-col gap-1.5 sm:gap-2 my-2 sm:my-3">
                  {Array.isArray(service?.offeredServices) && service.offeredServices.map((serviceOffer, idx) => (
                    <p
                      key={idx}
                      className="text-[12px] sm:text-[14px] font-openSans"
                    >
                      ✔ {serviceOffer}
                    </p>
                  ))}
                </div>
              </div>
              {/* button */}
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-2 mt-2">
                <Link
                  to="/appointment"
                  className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center sm:justify-start gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 group"
                >
                  Book Appointment{" "}
                  <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
                    <MoveRight
                      color="#000"
                      className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
                    />
                  </span>
                </Link>
                <Link
                  to={`/service-detail/${service?.slug || ""}`}
                  className="rounded-[8px] sm:rounded-[10px] py-2 px-3 text-[13px] sm:text-[14px] font-semibold text-[#1975FF] bg-white hover:bg-[#1975FF] hover:text-white hover:shadow-lg  active:bg-[#1560d4] active:scale-95 active:shadow-md transition-all duration-200 border border-[#1975FF]"
                >
                  View Detail
                </Link>
              </div>
            </div>
          </div>
            ))}
          </div>
        )}
      </div>
      {/* Care Process */}
      <h1 className="text-[22px] sm:text-[26px] md:text-[28px] font-semibold text-center mt-6 md:mt-8 leading-[1.2] px-4">
        Our Step-by-Step <br /> Care Process
      </h1>
      <p className="text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] text-center max-w-[750px] mx-auto mt-3 mb-6 leading-[1.4] px-4  font-openSans">
        Our step-by-step care process is designed to ensure a smooth and
        efficient patient journey—from initial consultation and accurate
        diagnosis to personalized treatment and continuous follow-up care,
        ensuring the best possible outcomes.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6 max-w-[1200px] mx-auto my-6 px-4">
        <div className="p-5 sm:p-6 rounded-[15px] sm:rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] active:shadow-md transition-all duration-500 border border-transparent cursor-pointer">
          <div className="bg-[#E3A1A166] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <Calendar
              color="#000"
              className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 group-hover:text-red-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[15px] sm:text-[18px] md:text-[20px] my-2 sm:my-2.5 leading-[1.2]">
            Book Appointment
          </p>
          <p className="max-w-[150px] mx-auto text-[12px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Schedule your visit online or by phone
          </p>
        </div>
        <div className="p-5 sm:p-6 rounded-[15px] sm:rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] active:shadow-md transition-all duration-500 border border-transparent cursor-pointer">
          <div className="bg-[#E4A77F66] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <UserCheck
              color="#000"
              className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 group-hover:text-blue-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[15px] sm:text-[18px] md:text-[20px] my-2 sm:my-2.5 leading-[1.2]">
            Doctor Consultation
          </p>
          <p className="max-w-[150px] mx-auto text-[12px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Meet with our expert specialists
          </p>
        </div>
        <div className="p-5 sm:p-6 rounded-[15px] sm:rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] active:shadow-md transition-all duration-500 border border-transparent cursor-pointer">
          <div className="bg-[#B8957A66] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <Clipboard
              color="#000"
              className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 group-hover:text-yellow-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[15px] sm:text-[18px] md:text-[20px] my-2 sm:my-2.5 leading-[1.2]">
            Diagnosis & <br /> Tests
          </p>
          <p className="max-w-[150px] mx-auto text-[12px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Undergo necessary medical tests
          </p>
        </div>
        <div className="p-5 sm:p-6 rounded-[15px] sm:rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] active:shadow-md transition-all duration-500 border border-transparent cursor-pointer">
          <div className="bg-[#7FAFB366] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <FileText
              color="#000"
              className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 group-hover:text-green-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[15px] sm:text-[18px] md:text-[20px] my-2 sm:my-2.5 leading-[1.2]">
            Personalized Treatment Plan
          </p>
          <p className="max-w-[150px] mx-auto text-[12px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Receive customized treatment
          </p>
        </div>
        <div className="p-5 sm:p-6 rounded-[15px] sm:rounded-[20px] text-center group hover:border-transparent hover:shadow-[0px_10px_35px_0px_#CECDDA66] hover:-translate-y-2 hover:bg-[#F8FAFF] active:scale-[0.98] active:shadow-md transition-all duration-500 border border-transparent cursor-pointer">
          <div className="bg-[#B7AAD666] p-3 md:p-4 rounded-full inline-block group-hover:bg-white group-hover:shadow-md transition-all duration-500">
            <Activity
              color="#000"
              className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 group-hover:text-green-500 transition-colors duration-500"
            />
          </div>
          <p className="font-semibold text-[15px] sm:text-[18px] md:text-[20px] my-2 sm:my-2.5 leading-[1.2]">
            Recovery & Follow-up Care
          </p>
          <p className="max-w-[150px] mx-auto text-black text-[12px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-[1.4]">
            Ongoing support and monitoring
          </p>
        </div>
      </div>
      {/*  Book Appointment  */}
      <div className="py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-8 mb-14">
        <h1 className="max-w-[550px] text-center text-[22px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Get Expert Medical Care Today
        </h1>
        <p className="max-w-[600px] font-openSans text-[14px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3">
          Book your consultation today and access expert healthcare services
          backed by experienced doctors, advanced diagnostics, and a seamless
          patient experience.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2.5 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
          >
            Book Appointment{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight
                color="#000"
                className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
              />
            </span>
          </Link>
          <a
            href="tel:+917300906444"
            className="border border-black rounded-[8px] sm:rounded-[10px] py-2.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black bg-white hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            <span className="p-2 bg-[#F59E0B] rounded-full transition-all duration-300 group-hover:bg-white">
              <Phone color="#ffffff" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </span>
            Call Now
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
